export default {
  title: 'Frais',
  subtitle: 'Remplacement des frais de service par restaurant pour {{company}}.',
  card_title: 'Frais de service',
  banner: {
    default_summary: 'Défaut partenaire : {{percentage}}% · min {{min}} · max {{max}}.',
    override_hint: 'Remplacez ci-dessous pour définir des frais différents pour ce restaurant.',
    suggested_summary: 'Valeurs de départ suggérées : {{percentage}} % · min {{min}} · max {{max}}.',
    suggested_hint: 'Ajustez-les ci-dessous et enregistrez pour facturer des frais de service dans ce restaurant.',
    own_fee_hint: 'Ce restaurant applique ses propres frais, définis ci-dessous.',
    saved_summary: 'Vos dernières valeurs enregistrées : {{percentage}} % · min {{min}} · max {{max}}.',
    saved_hint:
      "Les frais de service sont désactivés. Enregistrez ces valeurs, ou modifiez-les d'abord, pour les réactiver.",
  },
  form: {
    recommended: 'Recommandé : {{value}}',
    percentage: {
      label: 'Pourcentage des frais de service',
      tooltip: 'Pourcentage de la valeur de la commande facturé au client en frais de service.',
    },
    min_amount: {
      label: 'Montant minimum des frais de service',
      tooltip: 'Les frais calculés inférieurs à ce montant sont arrondis à ce montant.',
    },
    max_amount: {
      label: 'Montant maximum des frais de service',
      tooltip: 'Les frais de service ne dépassent jamais ce montant, quelle que soit la valeur de la commande.',
    },
  },
  limits:
    'Doit rester dans les limites FoodAmigos : max {{max_percentage}}% / {{max_amount}}, minimum au moins {{min_amount}}.',
  not_charged_notice:
    "Aucun frais de service n'est facturé dans ce restaurant actuellement. Enregistrez des frais ci-dessous pour les activer.",
  zero_percentage_warning:
    'Un pourcentage de 0 % ne désactive pas les frais de service : les frais calculés inférieurs au minimum sont arrondis à ce montant, donc chaque commande est toujours facturée au moins le minimum.',
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
    reset_to_default: 'Réinitialiser au défaut partenaire',
    turn_off: 'Désactiver les frais de service',
  },
  toasts: {
    load_error: 'Impossible de charger les paramètres de frais de service.',
    failed_to_save_changes: "Échec de l'enregistrement",
    changes_got_saved: 'Modifications enregistrées',
    reset_to_default: "Remplacement supprimé — le défaut partenaire s'applique.",
    reset_to_default_skipped:
      "Dérogation supprimée — aucun frais de service n'est appliqué tant que vous n'en enregistrez pas un.",
    turned_off: 'Frais de service désactivés. Vos valeurs sont conservées pour leur réactivation.',
  },
};
